import { type ReactNode, useEffect, useState } from "react";

export interface DelayedRenderProps {
  /** Delay in milliseconds before rendering children. */
  delay: number;
  /** Content to render after the delay. */
  children: ReactNode;
}

/**
 * Renders its children only after the given delay. Renders nothing until the delay has elapsed.
 */
export const DelayedRender = ({ delay, children }: DelayedRenderProps) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setReady(true), delay);
    return () => window.clearTimeout(id);
  }, [delay]);

  if (!ready) {
    return null;
  }

  return <>{children}</>;
};
